import { FuseNavigation } from "@fuse/types";
export const navigation: FuseNavigation[] = [
    {
        id: "applications",
        title: "Applications",
        type: "group",
        children: [
            {
                id: "home",
                title: "Dashboard",
                translate: "NAV.Home",
                type: "item",
                icon: "dashboard",
                url: "/dashboard",
            },
            {
                id: "load",
                title: "Loads",
                translate: "NAV.Loads",
                type: "item",
                icon: "grain",
                url: "/load",
            },

            {
                id: "cassette",
                title: "Cassettes",
                translate: "NAV.Cassettes",
                type: "collapsable",
                icon: "ballot",
                children: [
                    // {
                    //     id: "checkout",
                    //     title: "Prepare Set",
                    //     type: "item",
                    //     url: "/cassette/preparesets",
                    // },

                    // {
                    //     id: "checkout",
                    //     title: "New Prepare Set",
                    //     type: "item",
                    //     url: "/cassette/newpreparesets",
                    // },
                    // {
                    //     id: "checkout",
                    //     title: "View Prepared Sets",
                    //     type: "item",
                    //     url: "/cassette/viewpreparesets",
                    // },
                    {
                        id: "cassettes",
                        title: "List",
                        translate: "NAV.List",
                        type: "item",
                        url: "/cassette/cassette",
                    },
                    {
                        id: "checkout",
                        title: "Checkout",
                        translate: "NAV.Checkout",
                        type: "item",
                        url: "/cassette/assign",
                    },

                    {
                        id: "unassign",
                        title: "Unassign",
                        translate: "NAV.Unassign",
                        type: "item",
                        url: "/cassette/unassign",
                    },
                ],
            },

            {
                id: "patient",
                title: "Patients",
                translate: "NAV.Patients",
                type: "item",
                icon: "accessibility",
                url: "/patient",
            },
            {
                id: "report",
                title: "Reports",
                translate: "NAV.Reports",
                type: "item",
                icon: "assessment",
                url: "/report",
            },
        ],
    },
    {
        id: "wizecenter",
        title: "Wize Center",
        translate: "NAV.WizeCenter",
        type: "group",
        children: [
            {
                id: "academy",
                title: "Resource Center",
                translate: "NAV.ResourceCenter",
                type: "item",
                icon: "school",
                url: "/rcenter/newrc",
            },
            {
                id: "maintenance",
                title: "Maintenance",
                translate: "NAV.Maintenance",
                type: "collapsable",
                icon: "art_track",
                children: [
                    {
                        id: "maintenanceHistory",
                        title: "Sterilizer",
                        translate: "NAV.Sterilizer",
                        type: "item",
                        url: "maintenance/maintenanceHistory",
                    },
                    {
                        id: "othermachine",
                        title: "Other Machines",
                        translate: "NAV.OtherMachines",
                        type: "item",
                        url: "maintenance/othermachine",
                    },
                    {
                        id: "waterlineTest",
                        title: "Waterline Test",
                        translate: "NAV.WaterlineTest",
                        type: "item",
                        url: "maintenance/waterlineTest",
                    },
                ],
            },
            {
                id: "cases",
                title: "Lab Cases",
                translate: "NAV.Cases",
                type: "collapsable",
                icon: "assignment",
                children: [
                    {
                        id: "labCases ",
                        title: "Cases",
                        translate: "NAV.caseList",
                        type: "item",
                        url: "cases/cases-list",
                    },
                    // {
                    //   id: "labCasesViewReminder",
                    //   title: "View Reminder",
                    //   translate: "NAV.viewReminder",
                    //   type: "item",
                    //   url: "cases/view-reminder",
                    // },
                    {
                        id: "labCasesReminderHistory",
                        title: "Reminder History",
                        translate: "NAV.ReminderHistory",
                        type: "item",
                        url: "cases/reminder-history",
                    },
                ],
            },
            {
                id: "tickets",
                title: "Tickets",
                translate: "NAV.Tickets",
                type: "item",
                icon: "confirmation_number",
                url: "tickets/tickets-list",
            },
        ],
    },

    // {
    //     id: "department",
    //     title: "Department",
    //     type: "group",
    //     children: [

    //         {
    //             id: "cassettespatient",
    //             title: "Available Sets",
    //             type: "item",
    //             url: "/cassette/patientcheckoutList",
    //         },

    //         {
    //             id: "checkouts",
    //             title: "Checkout",
    //             type: "item",
    //             url: "/cassette/patientcheckout",
    //         },

    //     ],
    // },
    {
        id: "inventory",
        title: "Inventory",
        translate: "NAV.Inventory",
        type: "group",
        children: [
            {
                id: "label",
                title: "Labels Replenishment",
                translate: "NAV.LabelsReplenishment",
                type: "item",
                icon: "label",
                url: "/label",
            },
        ],
    },
    {
        id: "setting",
        title: "Settings",
        translate: "NAV.Settings",
        type: "group",
        children: [
            {
                id: "team",
                title: "Team",
                translate: "NAV.Team",
                type: "item",
                icon: "people",
                url: "/team",
            },
            // {
            //     id: "logs",
            //     title: "Logs",
            //     type: "item",
            //     icon: "ballot",
            //     url: "/logs",
            // },
            // {
            //     id: "questionconsent",
            //     title: "Screening Configuration",
            //     type: "collapsable",
            //     icon: "ballot",
            //     children: [
            //         {
            //             id: "consent",
            //             title: "Consent Form",
            //             type: "item",
            //             url: "/consent",
            //         },
            //         {
            //             id: "question",
            //             title: "Screening Questions",
            //             type: "item",
            //             url: "/question",
            //         },
            //         {
            //             id: "patientResolutionSetting",
            //             title: "Patient Resolution Settings",
            //             type: "item",
            //             url: "/screening/patientResolutionSetting",
            //         },
            //         {
            //             id: "staffResolutionSetting",
            //             title: "Staff Resolution Settings",
            //             type: "item",
            //             url: "/screening/staffResolutionSetting",
            //         },
            //         {
            //             id: "screeningEmailSetting",
            //             title: "Email Settings",
            //             type: "item",
            //             url: "/screening/screeningEmailSetting",
            //         },
            //     ],
            // },
            {
                id: "labconfig",
                title: "Lab Configuration",
                translate: "NAV.LabConfiguration",
                type: "item",
                icon: "group_work",
                url: "/lab",
            },
        ],
    },
    {
        id: "support",
        title: "Support",
        translate: "NAV.Support",
        type: "group",
        children: [
            // {
            //     id: 'Resource Center',
            //     title: 'Resource center',
            //     type: 'item',
            //     icon: 'help_center',
            //     url: '/support/rcenter'
            // },

            {
                id: "Training Center",
                title: "Training Center",
                translate: "NAV.TrainingCenter",
                type: "item",
                icon: "library_books",
                url: "/support/tcenter",
            },
            {
                id: "faq",
                title: "FAQs",
                translate: "NAV.FAQs",
                type: "item",
                icon: "record_voice_over",
                url: "/support/faq",
            },
            // {
            //     id: 'qrcode',
            //     title: 'Support',
            //     type: 'item',
            //     icon: 'record_voice_over',
            //     url: '/support/qrcode'
            // },

            //         // {
            //         //     id: 'knowledge-base',
            //         //     title: 'Knowledge Base',
            //         //     type: 'item',
            //         //     icon: 'import_contacts',
            //         //     url: '/support/knowledge-base'
            //         // },
            //         // {
            //         //     id: 'chat',
            //         //     title: 'Tickets',
            //         //     type: 'item',
            //         //     icon: 'chat',
            //         //     url: '/support/chat',
            //         // },
        ],
    },
];
